import { type NextRouter } from 'next/router'
import { useEffect, useMemo } from 'react'
import { EXPERT_DETAIL_TAB_KEY_ROUTES } from 'constants/routes'
import { usePublicExpertDetailSharedHeaderQuery } from 'types/graphql-generated'
import { pushUrl } from 'utils/pushUrl'

// Redirect to the first available tab if the current tab is not available
export const useExpertDetailRedirect = ({
  expertId,
  currentTab,
  router,
}: {
  expertId: number
  currentTab: string
  router: NextRouter
}) => {
  const { data: expertData, loading } = usePublicExpertDetailSharedHeaderQuery({
    fetchPolicy: 'cache-first',
    variables: {
      id: expertId,
    },
    skip: typeof expertId !== 'number',
  })

  const availableExpertDetailTabs = useMemo(
    () => expertData?.expert?.availableExpertDetailTabs || [],
    [expertData]
  )

  useEffect(() => {
    if (availableExpertDetailTabs.length > 0) {
      const isCurrentTabAvailable =
        availableExpertDetailTabs.includes(currentTab)

      if (isCurrentTabAvailable) {
        return
      }

      const route = EXPERT_DETAIL_TAB_KEY_ROUTES[availableExpertDetailTabs[0]]({
        slug: expertData.expert.slug,
      })

      if (route) {
        pushUrl({
          router,
          route,
        })
      }
    }
  }, [availableExpertDetailTabs, currentTab, expertData, router])

  return {
    expert: expertData?.expert,
    availableExpertDetailTabs,
    isLoading: loading,
  }
}
